import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../common/filters.component';

@Component({
	selector: 'app-vehicles-filters',
	templateUrl: './vehicles-filters.component.html',
	styleUrls: ['./vehicles-filters.component.css'],
})
export class VehiclesFiltersComponent extends FiltersComponent {
	@Input() parameters;

	filters = {
		vehicle_status: null,
	};
	protected filtersAfterLoad() {
		if (!this.filters.vehicle_status) {
			this.filters.vehicle_status = ['1', '5'];
		}
	}
	filtersDefault() {
		this.filters.vehicle_status = ['1', '5'];
	}
}
